import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '',
  success: true,
  duration: 3000,
  position: 'top-center',
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    showNotification: (state, action) => {
      const { message, success = true, duration = 3000, position = 'top-center' } = action.payload;
      state.open = true;
      state.message = message;
      state.success = success;
      state.duration = duration;
      state.position = position;
    },
    hideNotification: (state) => {
      state.open = false;
    },
  },
});

export const { showNotification, hideNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
